<template>
  <el-dialog
      :title="title"
      :visible.sync="localIsOpen"
      :width="width"
      :close-on-click-modal="false"
      @update:visible="handleUpdateVisible"
      @close="handleUpdateVisible"
  >
    <slot/>
  </el-dialog>
</template>

<script>
const props = {
  title: {
    type: String,
    required: true,
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
  width: {
    type: String,
  },
}

export default {
  props: props,
  data() {
    return {
      localIsOpen: this.isOpen
    }
  },
  watch: {
    isOpen(newVal) {
      this.localIsOpen = newVal;
    }
  },
  methods: {
    handleUpdateVisible() {
      this.localIsOpen = false;
      this.$emit('update:isOpen', false);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>